import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  circleProgress: {
    transform: "scale(1.5)",
  },
}));

function ProtectedRoute({ component: Component, returnTo = "/", ...rest }) {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  const [roleMatch, setRoleMatch] = React.useState(false);
  const [redirectMessage, setRedirectMessage] = React.useState("");

  const classes = useStyles();

  React.useEffect(() => {
    const role = returnTo.substring(1);

    if (isAuthenticated)
      (async () => {
        try {
          const accessToken = await getAccessTokenSilently();
          const res = await axios.get(
            `/.netlify/functions/server/api/checkrole/${role}`,
            {
              headers: {
                authorization: `Bearer ${accessToken}`,
              },
            }
          );
          setRoleMatch(await res.data.roleMatch);
        } catch (err) {
          console.log("Error: ", err.message);
          setRedirectMessage(
            `You are NOT authroize to access ${returnTo
              .substring(1)
              .toUpperCase()} page`
          );
        }
      })();
  }, [isAuthenticated, returnTo]);

  return (
    <Route
      {...rest}
      component={(props) => {
        if (isAuthenticated | isLoading && redirectMessage === "")
          return (
            <>
              {roleMatch ? (
                <Component {...props} />
              ) : (
                <>
                  <Backdrop className={classes.backdrop} open={true}>
                    <CircularProgress
                      color="Primary"
                      className={classes.circleProgress}
                    />
                  </Backdrop>
                </>
              )}
            </>
          );
        else {
          return (
            <>
              <Redirect
                to={{
                  pathname: `${returnTo}`,
                  state: {
                    from: props.location,
                    authorize: false,
                    message: `${redirectMessage}` || "You're NOT Logged-in",
                    severity: isAuthenticated ? "warning" : "error",
                  },
                }}
              />
            </>
          );
        }
      }}
    />
  );
}

export default ProtectedRoute;
